import {
  MetricsV1AggregationThresholdInput,
  MetricsV1FilterInput,
  MetricsV1ValueCapInput,
} from '@spotify/confidence-graphql';

import { expressionToSql, normalizeFilterInput } from '../../../helpers';
import { aggregationUtils } from '../../Aggregation';

export const filterToSqlPredicate = (
  filter: Maybe<MetricsV1FilterInput> | undefined,
): string | null => {
  const normalized =
    filter && filter.criteria.length > 0 ? normalizeFilterInput(filter) : null;
  return normalized ? expressionToSql(normalized) : null;
};

export const filterToWhereClause = (
  filter: Maybe<MetricsV1FilterInput> | undefined,
): string => {
  const normalized =
    filter && filter.criteria.length > 0 ? normalizeFilterInput(filter) : null;
  if (!normalized) {
    return '';
  }

  const predicate = expressionToSql(normalized, 2);
  if (!predicate.includes('\n')) {
    return `\n  WHERE ${predicate}`;
  }

  const indentedPredicate = predicate
    .split('\n')
    .map(line => `    ${line}`)
    .join('\n');
  return `\n  WHERE\n${indentedPredicate}`;
};

export const applyThreshold = (
  expr: string,
  threshold: Maybe<MetricsV1AggregationThresholdInput> | undefined,
): string => {
  if (!threshold) {
    return expr;
  }
  const { label } = aggregationUtils.getAggregationThresholdDirectionDetails(
    threshold.direction,
  );
  return `IF(${expr} ${label} ${threshold.threshold.value}, 1, 0)`;
};

export const applyCap = (
  expr: string,
  cap: Maybe<MetricsV1ValueCapInput> | undefined,
): string => {
  const min = cap?.min?.value;
  const max = cap?.max?.value;
  const hasMin = min !== null && min !== undefined && min !== '';
  const hasMax = max !== null && max !== undefined && max !== '';

  let result = expr;
  if (hasMax) {
    result = `LEAST(${result}, ${max})`;
  }
  if (hasMin) {
    result = `GREATEST(${min}, ${result})`;
  }

  return result;
};

export const coalesceToZeroIf = (
  expr: string,
  when: boolean | undefined,
): string => (when ? `IFNULL(${expr}, 0)` : expr);

const SAFE_IDENTIFIER = /^[A-Za-z_][A-Za-z0-9_]*$/;

export const quoteIdentifier = (name: string): string =>
  SAFE_IDENTIFIER.test(name) ? name : `"${name.replace(/"/g, '""')}"`;
